import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import FontIcon from 'components/FontIcon';
import SearchButtonB from 'components/SearchButton/SearchButtonB';
import classes from './SiteNavBMobileLevelA.module.scss';

const SiteNavBMobileLevelA = (props) => {
  const {
    imageUrl,
    imageLinkHref,
    imageLinkTarget,
    imageAltText,
    itemsCount,
    cartUrl,
    isMenuOpen,
    onMenuClick,
    siteId,
    searchResultsLinkHref,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <Link
          href={imageLinkHref}
          target={imageLinkTarget}
          className={classes.logo}
        >
          <img
            src={imageUrl}
            alt={imageAltText}
            width={240}
          />
        </Link>
        <div className={classes.rightNav}>
          <Link
            href={cartUrl}
            className={classes.icon}
          >
            <FontIcon icon='fas fa-shopping-cart' className={classes.iconCart}>
              {itemsCount > 0 ? <span className={classes.badge}>{itemsCount}</span> : null}
            </FontIcon>
          </Link>
          <SearchButtonB
            siteSearch360SiteId={siteId}
            siteSearch360SiteResults={searchResultsLinkHref}
            searchQueryString='search'
          />
          <button
            onClick={onMenuClick}
            className={classes.icon}
            type='button'
            aria-label='toggle-menu'
          >
            <FontIcon icon={isMenuOpen ? 'far fa-times' : 'far fa-bars'} className={classes.iconMobileMenu} />
          </button>
        </div>
      </div>
    </div>
  );
};

SiteNavBMobileLevelA.propTypes = {
  imageUrl: PropTypes.string,
  imageLinkHref: PropTypes.string,
  imageLinkTarget: PropTypes.string,
  imageAltText: PropTypes.string,
  itemsCount: PropTypes.number,
  cartUrl: PropTypes.string,
  isMenuOpen: PropTypes.bool,
  onMenuClick: PropTypes.func,
  siteId: PropTypes.string,
  searchResultsLinkHref: PropTypes.string,
};

export default SiteNavBMobileLevelA;
